export default __webpack_public_path__ + "static/media/SponsorBanner.e2357fb5.png";